import { Component, OnInit } from '@angular/core'
import { BackGroundCheckGateway } from '../../gateways/background-check-gateway'
import { BackGroundCheck } from '../../models/background-check'

@Component({
    selector: 'BackGroundCheck',
    templateUrl: 'background-check.component.html'
})

export class BackGroundCheckComponent implements OnInit {

    backgroundViewModel: BackGroundCheck[]

    constructor(
        private backGroundCheckGateway: BackGroundCheckGateway
    ) {
        this.backgroundViewModel = {} as BackGroundCheck[]
    }

    ngOnInit(): void {
        this.backGroundCheckGateway.getBackGroundCheckData().subscribe(
            (model: BackGroundCheck[]) => {
                this.backgroundViewModel = model
                alert(this.backgroundViewModel)
            }
        )
    }
}

